import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import VerifyEmail from "./pages/VerifyEmail";
import SharedReport from "./pages/SharedReport";
import SharedReports from "./pages/SharedReports";
import NotFound from "./pages/NotFound";
import { AuthContextProvider } from "./context/AuthContext";
import { LanguageContextProvider } from "./context/LanguageContext";
import Navbar from "./components/navbar";
import Protected from "./components/protected";
import RoleSelectionWrapper from "./components/RoleSelectionWrapper";
import LanguageSwitcher from "./components/LanguageSwitcher";

function App() {
  return (
    <div className="App">
      <LanguageContextProvider>
        <AuthContextProvider>
          <Navbar />
          <RoleSelectionWrapper>
            <Routes>
              <Route path="/" element={<Protected><Home /></Protected>} />
              <Route path="/signin" element={<Signin />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/shared/:shareId" element={<SharedReport />} />
              <Route path="/shared-reports" element={<Protected><SharedReports /></Protected>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </RoleSelectionWrapper>
          <LanguageSwitcher />
        </AuthContextProvider>
      </LanguageContextProvider>
    </div>
  );
}

export default App;
